/**
 * 日志工具函数
 */

const DEFAULT_MAX_LENGTH = 1000;

/**
 * 截断字符串
 */
function truncateString(str: string, maxLength: number): string {
  if (str.length <= maxLength) {
    return str;
  }
  return str.slice(0, maxLength) + `... [truncated, total ${str.length} chars]`;
}

/**
 * 将对象转换为可打印的字符串，超过指定长度时截断
 * @param value - 要打印的值
 * @param maxLength - 最大字符数，默认 1000
 */
export function stringifyForLog(value: unknown, maxLength: number = DEFAULT_MAX_LENGTH): string {
  try {
    const str = JSON.stringify(value, null, 2);
    return truncateString(str, maxLength);
  } catch {
    // 处理循环引用等情况
    const str = String(value);
    return truncateString(str, maxLength);
  }
}
